import { useQuery } from '@tanstack/react-query';

import { FormulaType } from '../../constants/formulaType';

import { BaseError } from '../../helpers/BaseError';

// models
import {
    FormulaCategory,
    FormulaDetailModel,
} from '../../models/formula.model';

// services
import API from '../../services/api';

import formulaKeys from './_queryKeys';

const getFormulas = async (
    categoryStatus: FormulaCategory,
    formulaType?: FormulaType,
) => {
    const { data } = await API.fetchFormulasByCategory(
        categoryStatus,
        formulaType && {
            message_type: formulaType,
        },
    );

    return data;
};

export default function useFormulasCatalogQuery(
    categoryStatus: FormulaCategory,
    formulaType?: FormulaType,
) {
    return useQuery<FormulaDetailModel[], BaseError>({
        queryKey: formulaKeys.formulaCatalog(categoryStatus, formulaType),
        queryFn: () => getFormulas(categoryStatus, formulaType),
    });
}
